<script>
    import { getContext } from "svelte";

    import { registerPageComplete } from '../../gtm';
    import { projectSettings, acceptedFileUploadList } from '../../config';
    import model from '../../stores/modelStore';

    import FormRow from '../../components/FormRow.svelte';
    import FormColumn from '../../components/FormColumn.svelte';
    import DropZone from '../../components/DropZone.svelte';
    import NavigationButtons from '../../components/NavigationButtons.svelte';
    import PageSection from "../../components/PageSection.svelte";
    import Form from "../../components/Form.svelte";

    // props
    export let pageTitle = null;
    export let disabled = false;
    export let persistUrl = null;
    export let lastVisitedPage = null;
    export let title = null;
    export let gtmPhase = null;

    let buttons = null;

    // dropzone config
    const registrationToken = getContext("registrationToken");
    const id = 'fileUploader';
    const options = {
            url: "/api/file-upload?token=" + $model.registrationToken,
            acceptedFiles: acceptedFileUploadList,
            fileUploadToken: registrationToken
        };

    // component state updating
    if (!disabled) {
        $model.lastPageVisited = lastVisitedPage;
        document.title = pageTitle;
    }

    $model.documentList = $model.documentList || [];

    const handleSubmit = async (e) => {
    	buttons.blockNext();

		let response = await model.saveModelAsync(persistUrl);

		if (!response.success) {
			console.log(displayError)
		} else {
            registerPageComplete(title, gtmPhase);
			buttons.next();
		}

		buttons.unblock();
    };
</script>

<PageSection>
    <Form {disabled} id="form-document-upload" on:submit={handleSubmit}>
    <FormRow class="justify-content-center confirmation-hide">
        <FormColumn>
            <h4 class="text-center">{projectSettings.classActionName}</h4>
            <p></p>
            <h2 class="text-center">Please upload your documents</h2>
            <p>
                Please provide documentary evidence of your purchase of the vehicle. Supporting documents may include purchase documents, leasing documents, financial statements, or insurance documents. 
            </p>
        </FormColumn>
    </FormRow>
	
	<div class="confirmation-box-shadow">
        <FormRow>
            <FormColumn>
                <DropZone {options}
                    {id}
                    {disabled}
                    message="<b>Upload files for your registration</b><br>Drag files here or click to upload"
                    bind:documentList={$model.documentList}></DropZone>
            </FormColumn>
        </FormRow>
    </div>

    <FormRow class="confirmation-hide">
            <FormColumn>
                <NavigationButtons bind:buttons
					nextPageLabel={$model.confirmationPage ? "Confirmation" : "Next"} />
            </FormColumn>
        </FormRow>
        </Form>
</PageSection>
